// Workaround for: https://github.com/bazelbuild/rules_nodejs/issues/1265
/// <reference types="google.maps" />

import { inject, Injectable } from '@angular/core';
import { ComponentStore, tapResponse } from '@ngrx/component-store';
import { NonNullDynamicState } from '@us/web/shared/data-access';
import { filter, tap } from 'rxjs';
import { switchMap } from 'rxjs';
import { tuiIsPresent } from '@taiga-ui/cdk';
import { GoogleMapsService } from '../services';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface PositionState extends NonNullDynamicState<'geocoderResults', google.maps.GeocoderResult[]> {}

const initialState: PositionState = {
    geocoderResults: [],
    status: 'pending',
    error: null
};

@Injectable()
export class PositionStore extends ComponentStore<PositionState> {
    private readonly googleMapsService = inject(GoogleMapsService);

    readonly geocoderResults$ = this.select(state => state.geocoderResults);

    readonly autocomplete = this.effect<string>(params$ =>
        params$.pipe(
            filter(tuiIsPresent),
            tap(() => this.patchState({ status: 'loading', error: null })),
            switchMap(address =>
                this.googleMapsService.getGeocode({ address }).pipe(
                    tapResponse(
                        data => {
                            this.patchState({
                                geocoderResults: data.results,
                                status: 'success',
                                error: ''
                            });
                        },
                        error => this.patchState({ status: 'error', error: error as unknown as string })
                    )
                )
            )
        )
    );

    constructor() {
        super({ ...initialState });
    }
}
